import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { HorizontalBar } from 'components/Charts/HorizontalBar'
import { HoursViewData } from '../../types'

import {
  Container,
} from './styles'

interface HourGraphicProps {
  data: HoursViewData[]
}

export function HourGraphic({
  data,
}: HourGraphicProps): JSX.Element {
  return (
    <Container>

      <Typography
        variant='content3'
        inlineStyles={{
          marginBottom: '20px',
          marginTop: '15px',
        }}
      >
        Distribuição da ocupação no período acima:
      </Typography>

      {data.map((item, index) => (
        <HorizontalBar
          key={index}
          hour={item.hour}
          percentage={item?.percentage}
          value={item?.value}
        />
      ))}
      
    </Container>
  )
}